export default __webpack_public_path__ + "static/3-ea3557ac84d16e38884b2cc7ea129eef.png";